<template>
  <div id="playground">
    <!-- <ul>
      <li
        v-for="todo in todos"
        :key="todo.id"
      >
        <span>{{ todo.text }}</span>
      </li>
    </ul> -->
    <ImageCropper
      :image="base64Image"
    >
    </ImageCropper>
    <v-card class="mb-2">
      <div>
        <div
          class="upload-btn-container"
          @click="triggerUpload"
        >
          <v-icon
            v-if="!base64Image"
            class="upload-add-icon"
          >
            mdi-plus
          </v-icon>
          <v-img
            v-if="base64Image"
            max-height="128"
            max-width="128"
            contain
            :src="base64Image"
          ></v-img>
          <v-btn
            absolute
            top
            right
            icon
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <!-- <v-file-input
          ref="avatarFileRef"
          v-model="avatarFile"
          label="Avatar"
          outlined
          dense
          capture="environment"
          accept="image/*"
          @change="handleFileChange"
        ></v-file-input> -->
        <input
          ref="avatarFileRef"
          class="d-none"
          type="file"
          capture="environment"
          accept="image/*"
          @change="handleFileChange"
        />
      </div>
      <v-card-text>
        <VueHtml2pdf
          ref="html2Pdf"
          :show-layout="false"
          :float-layout="false"
          :enable-download="true"
          :preview-modal="false"
          :paginate-elements-by-height="1400"
          filename="myPDF"
          :pdf-quality="2"
          :manual-pagination="false"
          pdf-format="a4"
          pdf-orientation="portrait"
        >
          <section slot="pdf-content">
            <p ref="testPrint">
              <!-- PDF Content Here -->
              <v-container>
                <v-img
                  max-height="300"
                  max-width="400"
                  contain
                  src="https://www.google.com.hk/images/branding/googlelogo/2x/googlelogo_color_272x92dp.png"
                ></v-img>
                <vue-qrcode
                  tag="img"
                  value="Hello, World!"
                  :options="{ width: 200 }"
                ></vue-qrcode>
                Why don't robots ever eat clocks? Because it always gives them ticks! Why was the robot so bad at baseball?
                Because it kept hitting all its files! Why did the AI go on a diet? Because it wanted to reduce its machine
                learning! What do you get when you cross a robot with a tractor? A trans-farmer! I hope you found these jokes
                entertaining!
              </v-container>
            </p>
          </section>
        </VueHtml2pdf>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="primary"
          @click="handlePrint"
        >
          Test Print
        </v-btn>
      </v-card-actions>
    </v-card>
    <i-total-calendar></i-total-calendar>
    <!-- <vc-calendar @dayclick="onDayClick" is-expanded :attributes='attrs' :rows="2" :columns="$screens({ default: 1, lg: 2 })" /> -->
    <v-dialog
      v-model="selectedOpen"
      eager
      transition="dialog-bottom-transition"
      width="unset"
      offset-x
    >
      <v-card
        color="grey lighten-4"
        flat
      >
        <v-toolbar
          :color="selectedEvent.color"
          dark
        >
          <v-btn icon>
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-toolbar-title>{{ selectedDay }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon>
            <v-icon>mdi-heart</v-icon>
          </v-btn>
          <v-btn icon>
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <h1>Signature</h1>
          <div id="VueSignaturePad">
            <VueSignaturePad
              ref="signaturePad"
              :custom-style="signatureStyle"
              height="200px"
            />
            <div>
              <v-btn
                text
                color="primary"
                @click="save"
              >
                Save
              </v-btn>
              <v-btn
                text
                color="secondary"
                @click="undo"
              >
                Undo
              </v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <div>
      <qrcode-scanner
        :qrbox="250"
        :fps="10"
        @result="onScan"
      />
      <br />
      <universal-input
        v-model="numericInputValue"
        :config="config"
      />
      <div>
        {{ debugMessage }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, nextTick, computed } from 'vue'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import { collection, addDoc } from 'firebase/firestore'

// import { useCollection } from 'vuefire'
import VueHtml2pdf from 'vue-html2pdf'
import { mdiClose } from '@mdi/js'
import UniversalInput from '@/components/CRUD/UniversalInput'
import ITotalCalendar from '@/components/Calendar/ITotalCalendar'
import QrcodeScanner from '@/components/QRCode/QrcodeScanner.vue'
import getDatabase from '@/firebase/index'
import ImageCropper from '@/components/Avatar/ImageCropper.vue'

const avatarFile = ref(null)
const avatarFileRef = ref(null)

function triggerUpload() {
  // console.log('avatarFileRef.value', avatarFileRef.value)

  avatarFileRef.value.click()
}

function toBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}

const base64Image = ref('')

function handleFileChange(files) {
  console.log('files', files)
  console.log('avatarFile', avatarFile)
  console.log('avatarFileRef', avatarFileRef)
  if (avatarFileRef.value.files && avatarFileRef.value.files.length > 0) {
    toBase64(avatarFileRef.value.files[0]).then(result => {
      console.log('result', result)
      base64Image.value = result
    })
  }
}

// import { collection } from 'firebase/firestore'

const html2Pdf = ref(null)

// console.log('getDatabase', getDatabase)
// const db = getDatabase()
// const todos = useCollection(collection(db, 'todos'))
// onMounted(async () => {
//   try {
//     console.log('html2Pdf', html2Pdf)

//     // const docRef = await addDoc(collection(db, 'public/course/1/'), {
//     //   first: 'Ada',
//     //   last: 'Lovelace',
//     //   born: 1815,
//     // })
//     // console.log('Document written with ID: ', docRef.id)
//   } catch (e) {
//     console.error('Error adding document: ', e)
//   }
// })

const date = new Date()
const year = date.getFullYear()
const month = date.getMonth()
const debugMessage = ref('')
const signatureStyle = ref({
  border: 'black 3px solid ',
})
const selectedDay = ref('')
const attrs = ref([
  {
    key: 'today',
    highlight: true,
    dates: new Date(),
  },
  {
    highlight: {
      color: 'purple',
      fillMode: 'light',
    },
    dates: new Date(year, month, 13),
  },
  {
    highlight: {
      color: 'purple',
      fillMode: 'outline',
    },
    dates: new Date(year, month, 14),
  },
])
const selectedOpen = ref(false)
const selectedElement = ref(null)
const selectedEvent = ref({})
const numericInputValue = ref(null)
const config = ref({
  propName: 'name',
  label: 'Dessert name',
  type: {
    inputType: 'number',
  },
})
const focus = ref('')
const lastMonth = computed(() => {
  const x = new Date()
  x.setDate(0) // 0 will result in the last day of the previous month
  x.setDate(20) // 1 will result in the first day of the month
  const dateString = x.toISOString().split('T')[0]

  return dateString
})
const testPrint = ref(null)
function handlePrint() {
  // Get HTML to print from element
  const prtHtml = testPrint.value.innerHTML
  console.log('prtHtml', prtHtml)

  // Get all stylesheets HTML
  let stylesHtml = ''
  for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
    stylesHtml += node.outerHTML
  }

  const printCnt = `<!DOCTYPE html>
      <html>
        <head>
          ${stylesHtml}
        </head>
        <body>
          ${prtHtml}
        </body>
      </html>`
  console.log('printCnt', printCnt)
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(printCnt)
  } else {
    const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')
    console.log('printCnt', printCnt)
    WinPrint.document.write(printCnt)
    setTimeout(() => {
      WinPrint.focus()
      WinPrint.print()
      WinPrint.close()
    }, 500)
  }

  return true
}
const signaturePad = ref(null)
function undo() {
  signaturePad.undoSignature()
}
function save() {
  const { isEmpty, data } = signaturePad.value.saveSignature()
  console.log(isEmpty)
  console.log(data)
}
function setToday() {
  focus.value = ''
}
function prev() {
  console.log('prev')
  calendarCurrMonth.value.prev()
  calendarLastMonth.value.prev()
}
function next() {
  console.log('next')
  calendarCurrMonth.value.next()
  calendarLastMonth.value.next()
}
function showEvent() {
// { nativeEvent, event }
  // console.log('showEvent', event)
  const open = () => {
    // this.selectedEvent = event
    // this.selectedElement = nativeEvent.target
    requestAnimationFrame(() => requestAnimationFrame(() => {
      selectedOpen.value = true
      nextTick(() => {
        signaturePad.value.resizeCanvas()
      })
    }))
  }

  if (selectedOpen.value) {
    selectedOpen.value = false
    requestAnimationFrame(() => requestAnimationFrame(() => open()))
  } else {
    open()
  }

  // nativeEvent.stopPropagation()
}
function onDayClick(day) {
  console.log(day)
  selectedDay.value = day.id
  showEvent()
}
function onScan(decodedText, decodedResult) {
  // handle the message here :)
  console.log('onScan decodedText, decodedResult', decodedText, decodedResult)
  alert(`scan result: ${decodedText}`)
}
const today = ref(new Date().toISOString().substring(0, 10))
const events = ref([
  {
    name: 'Weekly Meeting',
    start: '2022-10-30 09:00',
    end: '2022-10-30 13:00',
  },
])
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
.btn-toggle {
  flex-direction: column;
}

@media print {
    /* styles here */
  .not-print{
    display: none;
  }
  body {
    /* display: block !important; */
    -webkit-print-color-adjust:exact;
    print-color-adjust:exact;
  }
}
.print-window .not-print{
  display: none;
}

.upload-add-icon{
  font-size: 64px;
}
.upload-btn-container{
  border: 3px solid rgba(72, 79, 84, 0.68);
  border-radius: 5px;
  width: 128px;
  height: 128px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.remove-btn{
  z-index: 999;
  position: absolute !important;
  top:0;
  right:0;
}
.remove-container{
  width: 100%;
  height: 100%;
}
</style>
